module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.slideClass
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6fe35028!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-awesome-swiper/src/slide.vue
// module id = 2570
// module chunks = 115